import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_API()+'urzad/'

export default {

    getRaportCennikow(idLi,data) {
        return axios({
            method: 'get',
            url: URL + 'pUrzadCennikRaport?idLini='+idLi+'&dataCennika='+data,
        });
    },

    getRaportCennikowNew(idLi,data,rodz) {
        return axios({
            method: 'get',
            url: URL + 'pUrzadCennikRaportNew?idLini='+idLi+'&dataCennika='+data+'&rodz='+rodz,
        });
    },

    getRaportPerLiniaDaneUlgi(dataOd,dataDo) {
        return axios({
            method: 'get',
            url: URL + 'pUrzadDaneUlgi?dataOd='+dataOd+'&dataDo='+dataDo,
        });
    },

    getBiletyJednorazowe(dataOd,dataDo){
        return axios({
            method: 'get',
            url: URL + 'pUrzadBiletyJedn?dataOd='+dataOd+'&dataDo='+dataDo+'&dataSprzedazy=true',
        });
    },

    getpUrzadDaneUlgiRaport(dataOd,dataDo){
        return axios({
            method: 'get',
            url: URL + 'pUrzadDaneUlgiRaport?dataOd='+dataOd+'&dataDo='+dataDo,
        });
    },

    getpUrzadDaneUlgiLinie(dataOd,dataDo){
        return axios({
            method: 'get',
            url: URL + 'pUrzadDaneUlgiLinie?dataOd='+dataOd+'&dataDo='+dataDo,
        });
    },

    getpUrzadDoplatyDoGrupUlg(dataOd,dataDo){
        return axios({
            method: 'get',
            url: URL + 'pUrzadDaneUlgiRapDopGru?dataOd='+dataOd+'&dataDo='+dataDo,
        });
    },

    getpUrzadDoplatyDoGrupSuma(dataOd,dataDo){
        return axios({
            method: 'get',
            url: URL + 'pUrzadDaneUlgiRapDopSum?dataOd='+dataOd+'&dataDo='+dataDo,
        });
    },

    getpUrzadBiletyMiesieczne(dataOd,dataDo){
      return axios({
          method:'get',
          url:URL+'pUrzadBiletyMies?dataOd='+dataOd+'&dataDo='+dataDo,
      })
    },
}



// WEBPACK FOOTER //
// ./src/modules/urzadModule/UrzadService.js